import 'imask/esm/imask';
import { toRef, watch, h } from 'vue-demi';
import props from './props.js';
import useIMask from './composable.js';

var VALUE_PROPS = ['typed', 'unmasked', 'value', 'modelValue'];

function _extractOptionsFromProps(props) {
  props = Object.assign({}, props); // keep only defined props

  Object.keys(props).filter(function (prop) {
    return props[prop] === undefined;
  }).forEach(function (undefinedProp) {
    delete props[undefinedProp];
  });
  VALUE_PROPS.forEach(function (p) {
    return delete props[p];
  });
  return props;
}

var Component3 = {
  name: 'imask-input',
  inheritAttrs: false,
  setup: function setup(props, _ref) {
    var attrs = _ref.attrs;
        _ref.slots;
        var emit = _ref.emit;

    var _useIMask = useIMask(_extractOptionsFromProps(props), {
      emit: emit,
      onAccept: function onAccept() {
        // emit more events
        var v = masked.value;
        emit('accept:value', v);
        emit('update:value', v);
        emit('update:masked', v);
        emit('update:modelValue', v);
        emit('update:unmasked', unmasked.value);
        emit('update:typed', typed.value);
      },
      onComplete: function onComplete() {
        emit('complete:value', masked.value);
      }
    }),
        el = _useIMask.el;
        _useIMask.mask;
        var masked = _useIMask.masked,
        unmasked = _useIMask.unmasked,
        typed = _useIMask.typed;

    var pvalue = toRef(props, 'value');
    var pmodelValue = toRef(props, 'modelValue');
    var punmasked = toRef(props, 'unmasked');
    var ptyped = toRef(props, 'typed');
    masked.value = pmodelValue.value || pvalue.value || '';
    unmasked.value = punmasked.value;
    typed.value = ptyped.value;
    watch(pvalue, function (v) {
      return masked.value = v;
    });
    watch(pmodelValue, function (v) {
      return masked.value = v;
    });
    watch(punmasked, function (v) {
      return unmasked.value = v;
    });
    watch(ptyped, function (v) {
      return typed.value = v;
    });
    return function () {
      var data = Object.assign({}, attrs, {
        value: props.value ? props.value : props.modelValue,
        ref: el
      });

      if (!props.mask) {
        data.onInput = function (event) {
          emit('update:modelValue', event.target.value);
          emit('update:value', event.target.value);
        };
      }

      return h('input', data);
    };
  },
  props: Object.assign({
    // plugin
    modelValue: String,
    value: String,
    unmasked: String,
    typed: {}
  }, props),
  emits: ['update:modelValue', 'update:masked', 'update:value', 'update:unmasked', 'update:typed', 'accept', 'accept:value', 'accept:masked', 'accept:unmasked', 'accept:typed', 'complete', 'complete:value', 'complete:masked', 'complete:unmasked', 'complete:typed']
};

export { Component3 as default };
